import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ROUTES } from "@/app/routes";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import clsx from "clsx";
import { useNavigate } from "react-router";

const PetVaccinationStatus: React.FC<{ status: string; type: "vaccination" | "deworming"; className?: string }> = (
  props,
) => {
  const navigate = useNavigate();
  const { routeState } = useRouteInfo(ROUTES.ROOT.children.CUSTOMER_PROFILE.id);
  const { customerId, petId } = routeState.state as ICustomerProfileState;

  const getUnderlineColor = () => {
    switch (props.status) {
      case "Overdue":
        return "decoration-[#EF0303]";
      case "Due":
      case "Upcoming":
        return "decoration-[#FA8F34]";
      case "Missing data":
        return "decoration-[#FF5B5B]";
      case "Done":
        return "decoration-[#149463]";
      default:
        return "decoration-black";
    }
  };

  const handelClick = () => {
    const basePath = `/app/customer/profile/customer-details`;
    const vaccinationPath = `${basePath}/vaccination/${customerId}/${petId}`;
    const reminderPath = `${basePath}/reminder/${customerId}/${petId}`;
    if (props?.status === "Missing data") {
      navigate(`${vaccinationPath}?document_source=vaccination_status&&isAddVaccine=ADD_VACCINE`);
      return;
    }
    if (props?.status === "Done") {
      navigate(`${vaccinationPath}?document_source=vaccination_status`);
      return;
    }
    if (props?.status === "Due" || props?.status === "Upcoming" || props?.status === "Overdue") {
      const documentSource = props?.type === "vaccination" ? "vaccination_reminder" : "deworming_reminder";
      navigate(`${reminderPath}?document_source=${documentSource}`);
    }
  };

  return (
    <div
      className={clsx(
        "flex-row  items-center opacity-100 p-0 flex underline decoration-1 cursor-pointer",
        getUnderlineColor(),
        props?.className,
      )}
      onClick={() => handelClick()}
    >
      {props?.status === "Overdue" && <p className="text-theme-xs text-[#EF0303] font-medium">Overdue</p>}
      {(props?.status === "Due" || props?.status === "Upcoming") && (
        <p className="text-theme-xs text-[#FA8F34] font-medium">{props.status}</p>
      )}
      {props?.status === "Missing data" && (
        <p className="text-theme-xs text-[#FF5B5B] font-medium">Missing Data</p>
      )}
      {props?.status === "Done" && <p className="text-theme-xs text-[#149463] font-medium">Up to Date</p>}
    </div>
  );
};

export default PetVaccinationStatus;
